function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnsetLogoLight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  height: "100%",
  viewBox: "0 0 180 180",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  },
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,-124.438,-375)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 214.364,
  cy: 464.926,
  r: 89.926,
  style: {
    fill: "rgb(66,66,66)"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,-185.079,165.426)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.054,289.146L345.147,249.893C345.147,249.893 343.953,248.385 344.171,248.151C357.962,233.299 377.654,224 399.5,224C402.034,224 404.54,224.125 407.01,224.37C407.325,224.401 407.01,224.384 407.01,224.384L368.054,289.146Z",
  style: {
    fill: "rgb(236,180,172)"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.50957,0.860429,-0.860429,0.50957,453.534,-196.811)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.054,289.146L345.147,249.893C345.147,249.893 343.953,248.385 344.171,248.151C357.962,233.299 377.654,224 399.5,224C402.034,224 404.54,224.125 407.01,224.37C407.325,224.401 407.01,224.384 407.01,224.384L368.054,289.146Z",
  style: {
    fill: "rgb(189,208,197)"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.489957,-0.871747,0.871747,0.489957,-57.3237,500.797)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.054,289.146L345.147,249.893C345.147,249.893 343.953,248.385 344.171,248.151C357.962,233.299 377.654,224 399.5,224C402.034,224 404.54,224.125 407.01,224.37C407.325,224.401 407.01,224.384 407.01,224.384L368.054,289.146Z",
  style: {
    fill: "rgb(189,208,197)"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-0.501515,-0.865149,0.865149,-0.501515,340.55,794.858)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.054,289.146L345.147,249.893C345.147,249.893 343.953,248.385 344.171,248.151C357.962,233.299 377.654,224 399.5,224C402.034,224 404.54,224.125 407.01,224.37C407.325,224.401 407.01,224.384 407.01,224.384L368.054,289.146Z",
  style: {
    fill: "rgb(236,180,172)"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-0.999987,-0.00512807,0.00512807,-0.999987,797.941,601.045)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.054,289.146L345.147,249.893C345.147,249.893 343.953,248.385 344.171,248.151C357.962,233.299 377.654,224 399.5,224C402.034,224 404.54,224.125 407.01,224.37C407.325,224.401 407.01,224.384 407.01,224.384L368.054,289.146Z",
  style: {
    fill: "rgb(189,208,197)"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-0.485043,0.874491,-0.874491,-0.485043,855.067,95.3999)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.054,289.146L345.147,249.893C345.147,249.893 343.953,248.385 344.171,248.151C357.962,233.299 377.654,224 399.5,224C402.034,224 404.54,224.125 407.01,224.37C407.325,224.401 407.01,224.384 407.01,224.384L368.054,289.146Z",
  style: {
    fill: "rgb(236,180,172)"
  }
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnsetLogoLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onset-logo-light.aff670ab5f837354c22eff8c163ede3e.svg";